import { Alert, Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { Incident, TEMPERATURE_THRESHOLDS } from '../../types';
import {
  noIncidentsBoxStyles,
  successAlertStyles,
  warningAlertStyles,
} from './styles';

interface IncidentAlertsProps {
  incidents: ReadonlyArray<Incident>;
}

function areAlertsPropsEqual(
  prevProps: IncidentAlertsProps,
  nextProps: IncidentAlertsProps,
): boolean {
  return prevProps.incidents.length === nextProps.incidents.length;
}

const IncidentAlerts: React.FC<IncidentAlertsProps> = React.memo(
  ({ incidents }) => {
    const theme = useTheme();

    if (incidents.length === 0) {
      return (
        <>
          <Alert severity='success' sx={successAlertStyles(theme)}>
            {`No temperature incidents detected. All racks have been operating below ${TEMPERATURE_THRESHOLDS.INCIDENT}°C threshold.`}
          </Alert>
          <Box sx={noIncidentsBoxStyles(theme)}>
            <Typography variant='h6' color='success.main'>
              {`No incidents. All racks operating within safe temperature range.`}
            </Typography>
          </Box>
        </>
      );
    }

    return (
      <Alert severity='warning' sx={warningAlertStyles(theme)}>
        <strong>
          {incidents.length} incident{incidents.length !== 1 ? 's' : ''}
        </strong>
        {` recorded with temperature exceeding ${TEMPERATURE_THRESHOLDS.INCIDENT}°C threshold`}
      </Alert>
    );
  },
  areAlertsPropsEqual, // Custom comparison for performance optimization
);

IncidentAlerts.displayName = 'IncidentAlerts';

export default IncidentAlerts;
